import { FormGroup } from '@angular/forms';
import { AbstractDynamicForm, FormControlWrapper } from './../../../dynamic-form-abstract';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-dynamic-form-input-dependant-list',
  standalone: false,
  templateUrl: './dynamic-form-input-dependant-list.component.html',
  styleUrl: './dynamic-form-input-dependant-list.component.scss'
})
export class DynamicFormInputDependantListComponent {
	@Input() wrapper!: FormControlWrapper;
	@Input() form!: FormGroup;
	@Input() inline: boolean = false;
	@Input() readonly = false;
	@Input() span = 0;
	toControlKey = AbstractDynamicForm.toControlKey;
}
